// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__gvNnQ","topHeader":"Privacy_topHeader__snF-S","lastUpdated":"Privacy_lastUpdated__pdFoM","keyPoints":"Privacy_keyPoints__c009b"};